import React from 'react';
import '@xyflow/react/dist/style.css';
import { Handle, Position, NodeProps } from '@xyflow/react';
interface CustomNodeData {
  label: string;
  pros: string[];
  cons: string[];
  logos?: string[];
}
const CustomNode = ({
  data
}: NodeProps<CustomNodeData>) => {
  return <div className="relative" data-id="element-7">
      <Handle type="target" position={Position.Top} data-id="element-8" />
      <div className="bg-white shadow-md rounded-lg p-4 border border-gray-200 w-[28rem]" data-id="element-9">
        <div className="text-lg font-medium text-gray-800 mb-3 whitespace-pre-line" data-id="element-10">
          {data.label}
        </div>
        <div className="flex space-x-4" data-id="element-11">
          {/* Pros */}
          <div className="flex-1" data-id="element-12">
            <ul className="text-xs space-y-1" data-id="element-13">
              {data.pros.map((pro, index) => <li key={`pro-${index}`} className="bg-green-50 text-green-800 p-1.5 rounded" data-id="element-14">
                  {pro}
                </li>)}
            </ul>
          </div>
          {/* Cons */}
          <div className="flex-1" data-id="element-15">
            <ul className="text-xs space-y-1" data-id="element-16">
              {data.cons.map((con, index) => <li key={`con-${index}`} className="bg-red-50 text-red-800 p-1.5 rounded" data-id="element-17">
                  {con}
                </li>)}
            </ul>
          </div>
        </div>
        {/* Logos section */}
        {data.logos && data.logos.length > 0 && <div className="mt-4 flex space-x-2 items-center" data-id="element-18">
            {data.logos.map((logo, index) => <img key={`logo-${index}`} src={logo} alt="Database Logo" className="h-6 w-auto object-contain" data-id="element-19" />)}
          </div>}
      </div>
      <Handle type="source" position={Position.Bottom} data-id="element-20" />
    </div>;
};
export default CustomNode;